import Highlight, { defaultProps } from "prism-react-renderer"
import theme from "prism-react-renderer/themes/nightOwl"
import React from "react"
//import styled from 'styled-components'
import { makeStyles } from "@material-ui/core/styles"
import clsx from "clsx"
import copyToClipboard from "../lib/copyToClipboard"
/*
export const Pre = styled.pre`
  text-align: left;
  margin: 1em 0;
  padding: 0.5em;
  overflow-x: auto;
  border-radius: 3px;

  & .token-line {
    line-height: 1.3em;
    height: 1.3em;
  }
  font-family: Consolas,'Courier New', Courier, monospace;
`

export const LineNo = styled.span`
  display: inline-block;
  width: 2em;
  user-select: none;
  opacity: 0.3;
`

const CopyCode = styled.button`
2  position: absolute;
3  right: 0.25rem;
4  border: 0;
5  border-radius: 3px;
6  margin: 0.25em;
7  opacity: 0.3;
8  &:hover {
9    opacity: 1;
10  }
11`
*/

const CodeStyle = theme => ({
  linieNo: {
    display: "inline-block",
    width: "2em",
    userSelect: "none",
    opacity: 0.3,
  },
  pre: {
    position: "relative",
    textAlign: "left",
    margin: "1em 0",
    padding: "1em",
    overflowX: "auto",
    borderRadius: 3,
    "& .token-line": {
      lineHeight: "1.3em",
      height: "1.3em",
    },
    fontFamily:
      "Menlo,Consolas,Monaco,Droid Sans Mono,Courier New, Courier, monospace",
  },
  copyButton: {
    position: "absolute",
    right: "0.25rem",
    border: 0,
    borderRadius: 3,
    margin: "0.25em",
    opacity: 0.3,
    "&:hover": {
      opacity: 1,
    },
  },
  CodeInline: {
    fontFamily:
      "Menlo,Consolas,Droid Sans Mono,Courier New, Courier, monospace",
    backgroundColor: "lightgray",
    borderRadius: "0.2em",
    padding: "0 0.25em",
  },
})

const useStyles = makeStyles(CodeStyle)

const LineNumber = ({ children }) => {
  const classes = useStyles()
  return <span className={classes.linieNo}>{children}</span>
}

const CodeBlock = ({ codeString, language, ...props }) => {
  const classes = useStyles()

  const handleClick = () => {
    copyToClipboard(codeString)
  }

  return (
    <Highlight
      {...defaultProps}
      code={codeString}
      language={language}
      theme={theme}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={clsx(classes.pre, className)} style={style}>
          <button className={classes.copyButton} onClick={handleClick}>
            Copy
          </button>
          {tokens.map((line, i) => (
            <div {...getLineProps({ line, key: i })}>
              <LineNumber>{i + 1}</LineNumber>
              {line.map((token, key) => (
                <span {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  )
}

export default CodeBlock

const CodeInline = props => {
  const classes = useStyles()
  const { className, ...rest } = props
  return <code className={clsx(classes.CodeInline, className)} {...rest} />
}

export { CodeBlock, CodeInline }
